import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="star-rating"
export default class extends Controller {
  static targets = ["star", "input"]

  connect() {
    // Check if there's an initial value from the input field
    this.selectedRating = parseInt(this.inputTarget.value) || 0
    this.highlightStars(this.selectedRating)
  }

  hover(event) {
    const rating = parseInt(event.currentTarget.dataset.rating)
    this.highlightStars(rating)
  }

  unhover() {
    this.highlightStars(this.selectedRating)
  }

  select(event) {
    this.selectedRating = parseInt(event.currentTarget.dataset.rating)
    this.inputTarget.value = this.selectedRating
    this.highlightStars(this.selectedRating)
  }

  highlightStars(rating) {
    this.starTargets.forEach((star, index) => {
      if (index < rating) {
        star.classList.add("active")
      } else {
        star.classList.remove("active")
      }
    })
  }
}
